module.exports = __webpack_public_path__ + "static/media/cat-shoes.d1db9953.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/cat-shoes.jpg
// module id = 1177
// module chunks = 33